import React, { useEffect } from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import get from "lodash/get";
import { urlParam } from "utils/helpers";
import Spinner, { styles } from "components/Spinner";
import AuthorizationStatus from "./AuthorizationStatus";
import AuthorizationForm from "./AuthorizationForm";
import { fetchAuthorizerDetails } from "ducks/actions";
import {
  makeSelectIsFetchingData,
  makeSelectAuthorizedDeliveryDetails,
  makeSelectAuthorizedUserValues,
  makeSelectSessionToken
} from "ducks/selectors";
import NotEligible from "../../components/NotEligible";

const Authorization = props => {
  const {
    match,
    fetchAuthorizerDetails,
    authorizedUser,
    location,
    isSubmitting,
    sessionToken
  } = props;

  const { status: deliveryStatus } = get(match, "params", {});

  const token = sessionToken || urlParam("token");
  const nextPage = get(location, "pathname", "") + "/success";

  const updatedProps = {
    ...props,
    deliveryStatus,
    token,
    nextPage
  };

  useEffect(
    () => {
      if (!deliveryStatus && token) {
        const params = { token };
        fetchAuthorizerDetails(params);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [token, deliveryStatus]
  );

  if (!token) {
    return <NotEligible />;
  }

  if (!authorizedUser || isSubmitting)
    return <Spinner size={200} sx={styles.fullPage} />;

  const AuthorizationComponent = deliveryStatus
    ? AuthorizationStatus
    : AuthorizationForm;

  return <AuthorizationComponent {...updatedProps} />;
};

const mapStateToProps = state => {
  return createStructuredSelector({
    authorizedUser: makeSelectAuthorizedUserValues(),
    isSubmitting: makeSelectIsFetchingData("submitAuthorizeDelivery"),
    authorizeDelivery: makeSelectAuthorizedDeliveryDetails(),
    sessionToken: makeSelectSessionToken()
  });
};

export const mapDispatchToProps = dispatch => {
  return {
    fetchAuthorizerDetails: params => dispatch(fetchAuthorizerDetails(params))
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect)(Authorization);
